var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"account-page"},[_c('MutantHeader',{attrs:{"title":"ACCOUNT"}}),_vm._v(" "),_c('div',{staticClass:"account-view-wrapper"},[_vm._v("\n    YOLO\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }